export const aciVan = {
    iconName: 'van',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M18 16a1.333 1.333 0 11-2.667 0A1.333 1.333 0 0118 16zM7.333 16a1.333 1.333 0 11-2.667 0 1.333 1.333 0 012.667 0zM15.333 16h-8',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M18 16h2.667A1.333 1.333 0 0022 14.666l-.295-1.771a2.666 2.666 0 00-2.63-2.228h-1.742l-2.536-3.55A2.667 2.667 0 0012.627 6H4a2 2 0 00-2 2v3.568',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M4.667 16H4a2 2 0 01-2-2v-3.913M17.334 10.666H2M11.334 6v10M6.667 10.667V6',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
